module.exports = __webpack_public_path__ + "static/media/coin.3aa6d338.svg";